import React, { useRef, useState } from "react";
import { Modal, Select, Tooltip } from "antd";

import {
  ExpandOutlined,
  CompressOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import ClientsAssign from "./BulkModalFiles/ClientsAssign";
import ProducerAssign from "./BulkModalFiles/ProducerAssign";
import LanguageAssign from "./BulkModalFiles/LanguageAssign";
import UserAssign from "./BulkModalFiles/UserAssign";

const BulkActionsModal = ({
  open,
  onClose,
  userInfo,
  initialSelectedRowKeys,
  initialCurrentPage,
  initialPageSize,
  initialUrl,
  isCAAdmin,
  loadAgain,
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const startState = isCAAdmin ? "user_assign" : "Client_assign";
  const [selectedBulkAction, setSelectedBulkAction] = useState(startState);
  const clientsAssignRef = useRef();
  const producerAssignRef = useRef();
  const languageAssign = useRef();
  const handleClose = () => {
    setSelectedBulkAction(startState);
    if (clientsAssignRef.current && clientsAssignRef.current.handleCloseChild) {
      clientsAssignRef.current.handleCloseChild();
    }
    if (
      producerAssignRef.current &&
      producerAssignRef.current.handleCloseChild
    ) {
      producerAssignRef.current.handleCloseChild();
    }
    if (languageAssign.current && languageAssign.current.handleCloseChild) {
      languageAssign.current.handleCloseChild();
    }
  };

  const bulkActionOptions = [
    !isCAAdmin && { value: "Client_assign", label: "Client Assign" },
    !isCAAdmin && { value: "Producer_assign", label: "Producer Assign" },
    isCAAdmin && { value: "user_assign", label: "User Assign" },
    // isCAAdmin && { value: "bundle_assign", label: "Bundle Assign" },
    { value: "Language_assign", label: "Language Assign" },
  ].filter(Boolean);

  let ChildComponent = null;
  const sharedProps = {
    open,
    onClose,
    userInfo,
    initialSelectedRowKeys,
    initialCurrentPage,
    initialPageSize,
    initialUrl,
    setFullscreen,
    fullscreen,
    loadAgain,
  };

  const childKey = `${selectedBulkAction}-${open ? "open" : "closed"}`;

  if (open) {
    switch (selectedBulkAction) {
      case "Client_assign":
        ChildComponent = (
          <ClientsAssign
            key={childKey}
            ref={clientsAssignRef}
            {...sharedProps}
          />
        );
        break;

      case "user_assign":
        ChildComponent = (
          <UserAssign key={childKey} ref={clientsAssignRef} {...sharedProps} />
        );
        break;
      case "Producer_assign":
        ChildComponent = (
          <ProducerAssign
            key={childKey}
            ref={producerAssignRef}
            {...sharedProps}
          />
        );
        break;
      case "Language_assign":
        ChildComponent = (
          <LanguageAssign
            key={childKey}
            ref={languageAssign}
            {...sharedProps}
          />
        );
        break;
      default:
        ChildComponent = null;
    }
  }
  return open ? (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 18 }}>
            Bulk Actions
            <Select
              style={{ marginLeft: "15px", minWidth: 160 }}
              value={selectedBulkAction}
              onChange={setSelectedBulkAction}
            >
              {bulkActionOptions.map((opt) => (
                <Select.Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Select.Option>
              ))}
            </Select>
          </span>
        </div>
      }
      width={fullscreen ? "100vw" : 1300}
      style={fullscreen ? { top: 0, padding: 0, height: "100vh" } : {}}
      styles={{
        body: fullscreen
          ? { height: "calc(100vh - 100px)", overflow: "auto", padding: 0 }
          : { maxHeight: 800, overflow: "auto", padding: 0 },
      }}
      closeIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            marginRight: 40,
          }}
        >
          <Tooltip title={fullscreen ? "Exit Fullscreen" : "Expand"}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: fullscreen ? "#f0f0f0" : "transparent",
                boxShadow: fullscreen ? "0 0 4px #ccc" : "none",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreen((prev) => !prev);
              }}
            >
              {fullscreen ? <CompressOutlined /> : <ExpandOutlined />}
            </span>
          </Tooltip>
          <Tooltip title="Close">
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: "#f0f0f0",
                boxShadow: "0 0 4px #ccc",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseOutlined />
            </span>
          </Tooltip>
        </div>
      }
    >
      {ChildComponent}
    </Modal>
  ) : null;
};

export default BulkActionsModal;
